import en from './help.en';

const enConfig = { en };

export default enConfig;
